import styled from '@emotion/styled/macro';

export const ShareMobileWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 0 auto;
    justify-content: center;

    @media (min-width: 1024px) {
        margin: 0 0 12px 0;
    }
`;

export const ButtonWrapper = styled.div`
    height: 48px;
    width: 100%;
    max-width: 343px;
`;

export const ShareMobileButtonWrapper = styled(ButtonWrapper)`
    margin-right: 8px;

    @media (max-width: 1024px) {
        margin: 0 0 12px 0;
    }

    button {
        border-radius: 8px;
    }
`;
